export default function getOrdinal (number: number, tag:string) {
    if(tag === 'en-GB'){
        let ordinalArray=["th","st","nd","rd"],
        value = number%100;
        return number+(ordinalArray[(value-20)%10]||ordinalArray[value]||ordinalArray[0]);
    }else{
        return `${number}º`
    }
    
}